(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@cainiaofe/cn-ui-m"), require("@ali/visualengine"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@cainiaofe/cn-ui-m", "@ali/visualengine"], factory);
	else if(typeof exports === 'object')
		exports["cn-ui-m-lowcode"] = factory(require("react"), require("@cainiaofe/cn-ui-m"), require("@ali/visualengine"));
	else
		root["cn-ui-m-lowcode"] = factory(root["React"], root["CNUIM"], root["VisualEngine"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__38__) {
return 